export const FX_DYNAMIC_TABULAR_COLUMN_LIMIT = 50;
export const FX_DYNAMIC_TABULAR_ROW_LIMIT = 100;

export const FX_DYNAMIC_TABULAR_CHAR_LIMIT_PER_CELL = 1_024;
